export const MuiLink = {
  styleOverrides: {
    root: {
      fontWeight: '500',
      cursor: 'pointer',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  },
  defaultProps: {
    color: 'rgb(88, 166, 255)'
  }
}
